var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.symbol.dispose.js
// module id = 1101
// module chunks = 0